export function selectable(object: any): object is Selectable {
    return "select" in object && "unselect" in object;
}

export interface Selectable {
    select();

    unselect();
}

export class DefaultSelectable extends Phaser.GameObjects.Container implements Selectable {
    constructor(scene: Phaser.Scene, x: number, y: number) {
        super(scene, x, y);
    }

    public select() {
        this.each((elem) => {
            if (selectable(elem)) {
                elem.select();
            }
        });
    }

    public unselect() {
        this.each((elem) => {
            //            console.log('print each: ', elem);
            if (selectable(elem)) {
                elem.unselect();
            }
        });
    }

    // public destroy() {
    //     console.log('destroying selectable object');
    // }
}

export class StyleOptions {
    public paddingLeft: number = 0;
    public paddingRight: number = 0;
    public paddingBottom: number = 0;
    public paddingTop: number = 0;
    public spaceBetween: number = 0;
}
